// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","Logo":"Header_Logo__QSduJ","header__content":"Header_header__content__84c4B"};